$(function() {
  cartJSEvent();
  updateGWPbar();

  $(window).on('resize', function() {
    console.log('resize screen');
      
    try {
      // initCollectionListFlickity();
      // console.log('init flickity');
    } catch (error) {
        console.log('Error in resize handler:', error);
    }
      
  });
});

initCollectionListFlickity = () => {
  
  var $coll_list_slider = $('.jsc-collection-list-slider .collection-list__items');

  if ($coll_list_slider.length > 0) {
    if ($(window).width() >= 1024) {
      $coll_list_slider.each(function() {
        // $(this).flickity('destroy');

        $(this).flickity({
          cellAlign: 'left',
          contain: true,
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false
        });
      });
    }
    else {
      $coll_list_slider.each(function() {
        $(this).flickity('destroy');
      });
    }
  }
}


// start: CartJS Function
cartJSEvent = () => {
  window.__jscLastCartItemCount = window.__jscLastCartItemCount ?? null;
  $(document).on('cart.requestComplete', function(event, cart) {
    console.log('cart updated');
    if (location.href.includes('/cart')) {
      $('.jsc-page-loading').remove();
      location.reload();
    } else {
      const lastCount = window.__jscLastCartItemCount;
      const currentCount = typeof cart?.item_count === 'number' ? cart.item_count : null;
      const resetTerms = lastCount === null ? true : currentCount !== null && currentCount > lastCount;
      window.__jscLastCartItemCount = currentCount;

      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true, detail: { open: open, resetTerms }
      }));
      setTimeout(function() {
        updateGWPbar();
      }, 1000);
    }
  });
  $(document).on('cart.requestStarted', function(event, cart) {
    if (location.href.includes('/cart')) {
      var $html = `<div class="jsc-page-loading">
                  <div class="jsc-spinner-container">
                    <div class="jsc-loading-text">Updating your cart...</div>
                  </div>
                </div>`;
      $('body').prepend($html);
    }
    console.log('updating cart');
  });
}

cartJSAddQuery = (vid, qty, obj) => {
  // Cart js add item, success callback, error callback

  CartJS.addItem(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

cartJSUpdateQuery = (vid, qty, obj) => {
  // Cart js add item, success callback, error callback

  CartJS.updateItemById(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {

      if (location.href.includes('/cart')) {
        //reload only the product details section in cart page
        //console.log('data.item_count',data.item_count);
        
        if (!data.item_count) { // if cart is empty do this
          $(".jsc-cart-container").load(location.href+" .jsc-cart-container>*","");
          // console.log('reload empty cart section');
        }
      }
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}
// end: CartJS Function

// start: GWP based on cart, product or collection promo
cartGift = () =>{
  addCartGift();
  removeCartGift();
}

addCartGift = () =>{
  var $elem = $('.jsc-cart-gift');
  $elem.each(function() {
    var $vid = parseInt($(this).val());
    var $obj = {};
    var $promoNo = $(this).attr('data-promo');

    $obj['_Cart_Gift'] = $promoNo;
    $obj['_Cart_GWP'] = 'Free Gift';
    if ($elem.length > 0) {
      cartJSAddQuery($vid, 1, $obj);
    }
  });
}

removeCartGift = () =>{
  var $elem = $('.jsc-cart-gift-remove');
  $elem.each(function() {
    var $key = parseInt($(this).val());

    if ($elem.length > 0) {
      cartJSUpdateQuery($key, 0, {});
    }
  });
}
// end: GWP based on cart, product or collection promo


//Start GWP Tier promo
gwpTierFunction = (isOpenDrawer) =>{
  console.log('gwpTierFunction');
  // $.when($.getJSON('/cart.js', function(cart) {
  
  // })).then(function(cart){
    var $deleteEle = $('.jsc-remove-gwp');

    if ($deleteEle.length > 0) { // remove previous tier product first
        $deleteEle.each(function() {
          var $vid = $(this).val();
          var $qty = 0;
          console.log('remove tier',$vid);
          cartJSUpdateQuery($vid, $qty, {}, false);
        });
    }
    else { // add current tier product after previous tier product is removed
      var $ele = $('._cartGwp');

      $ele.each(function() {
        var $gwpcart_product = {};
        var $vid = parseInt($(this).attr('data-vid'));
        var $tierNo = $(this).attr('data-tier');
        var $tierCol = $(this).attr('data-col');
        $gwpcart_product['_GWP Tier ' + $tierNo] = true;
        $gwpcart_product['_Cart_GWP'] = 'Free Gift';
        if ( $tierCol ) {
          $gwpcart_product['_GWP_col'] = $tierCol;
        }
        
        if ($(this).length > 0) {
          cartJSAddQuery($vid, 1, $gwpcart_product, false);
        }
      });
    }
  
  // });

}
removeTierGift = () =>{
  var $deleteEle = $('.jsc-remove-gwp');

  if ($deleteEle.length > 0) {
      $deleteEle.each(function() {
        var $vid = $(this).val();
        var $qty = 0;
        console.log('remove tier',$vid);
        cartJSUpdateQuery($vid, $qty, {}, false);
      });
  }

}
//End GWP Tier promo

masterPromo = () =>{
  if (window.__gwpPriority && window.__gwpPriority.enabled && window.__gwpPriority.order) {
    masterPromoPriority();
  } else {
    const isDrawer = location.href.includes('/cart') ? false : true;
    gwpTierFunction(isDrawer);
    cartGift();
  }
}

// start: GWP Priority System
parsePriorityOrder = (orderStr) => {
  if (!orderStr) return [];
  return orderStr.split(',').map(function(s) { return s.trim().toUpperCase(); }).filter(function(s) { return s; });
}

getPriorityRank = (promoCode, priorityOrder) => {
  var idx = priorityOrder.indexOf(promoCode);
  return idx === -1 ? priorityOrder.length : idx;
}

identifyGWPInCart = (cartItems) => {
  var result = [];
  for (var i = 0; i < cartItems.length; i++) {
    var item = cartItems[i];
    var props = item.properties || {};

    // Check G-type (Cart/Product/Collection promo)
    if (props['_Cart_Gift']) {
      result.push({
        key: item.key,
        promoCode: 'G' + parseInt(props['_Cart_Gift']),
        type: 'G'
      });
      continue;
    }

    // Check M-type (Multi Gift Tier) - _GWP Tier 1 through _GWP Tier 10
    for (var t = 1; t <= 10; t++) {
      if (props['_GWP Tier ' + t]) {
        result.push({
          key: item.key,
          promoCode: 'M' + t,
          type: 'M'
        });
        break;
      }
    }
  }
  return result;
}

collectDOMDirectives = () => {
  var removeKeys = [];
  var addItems = [];

  // G-type removals (eligibility lost)
  $('.jsc-cart-gift-remove').each(function() {
    removeKeys.push({ key: $(this).val(), rawKey: parseInt($(this).val()) });
  });

  // M-type removals (tier change)
  $('.jsc-remove-gwp').each(function() {
    removeKeys.push({ key: $(this).val(), rawKey: $(this).val() });
  });

  // G-type additions
  $('.jsc-cart-gift').each(function() {
    var promoNo = $(this).attr('data-promo');
    addItems.push({
      promoCode: 'G' + promoNo,
      type: 'G',
      vid: parseInt($(this).val()),
      properties: { '_Cart_Gift': promoNo, '_Cart_GWP': 'Free Gift' }
    });
  });

  // M-type additions
  $('._cartGwp').each(function() {
    var tierNo = $(this).attr('data-tier');
    var tierCol = $(this).attr('data-col');
    var props = { '_Cart_GWP': 'Free Gift' };
    props['_GWP Tier ' + tierNo] = true;
    if (tierCol) { props['_GWP_col'] = tierCol; }
    addItems.push({
      promoCode: 'M' + tierNo,
      type: 'M',
      vid: parseInt($(this).attr('data-vid')),
      properties: props
    });
  });

  return { removeKeys: removeKeys, addItems: addItems };
}

masterPromoPriority = () => {
  var config = window.__gwpPriority;
  if (!config || !config.enabled || !config.order) return;

  var priorityOrder = parsePriorityOrder(config.order);
  var cap = config.cap || 3;
  var dom = collectDOMDirectives();

  // Phase 1: Process eligibility-based removals first (promo disabled, schedule expired, tier changed)
  if (dom.removeKeys.length > 0) {
    console.log('[GWP Priority] Processing eligibility removals:', dom.removeKeys.length);
    dom.removeKeys.forEach(function(r) {
      cartJSUpdateQuery(r.rawKey, 0, {});
    });
    return; // Next cycle handles audit + additions after removals settle
  }

  // Phase 2: Fetch cart and apply priority/cap logic
  $.getJSON('/cart.js', function(cart) {
    var existingGWP = identifyGWPInCart(cart.items);

    // Unique existing promo codes
    var existingCodes = [];
    existingGWP.forEach(function(g) {
      if (existingCodes.indexOf(g.promoCode) === -1) existingCodes.push(g.promoCode);
    });

    // Unique new eligible promo codes (not already in cart)
    var eligibleNewCodes = [];
    dom.addItems.forEach(function(a) {
      if (existingCodes.indexOf(a.promoCode) === -1 && eligibleNewCodes.indexOf(a.promoCode) === -1) {
        eligibleNewCodes.push(a.promoCode);
      }
    });

    var allCodes = existingCodes.concat(eligibleNewCodes);

    console.log('[GWP Priority] Existing:', existingCodes, 'New eligible:', eligibleNewCodes, 'Total:', allCodes.length, 'Cap:', cap);

    if (allCodes.length <= cap) {
      // Under cap: add all new eligible promos
      if (eligibleNewCodes.length > 0) {
        console.log('[GWP Priority] Under cap, adding:', eligibleNewCodes);
        eligibleNewCodes.forEach(function(pc) {
          dom.addItems.filter(function(a) { return a.promoCode === pc; }).forEach(function(item) {
            cartJSAddQuery(item.vid, 1, item.properties);
          });
        });
      }
    } else {
      // Over cap: sort by priority, keep highest-priority promos up to cap
      allCodes.sort(function(a, b) {
        return getPriorityRank(a, priorityOrder) - getPriorityRank(b, priorityOrder);
      });

      var keepCodes = allCodes.slice(0, cap);
      var dropCodes = allCodes.slice(cap);

      console.log('[GWP Priority] Over cap. Keep:', keepCodes, 'Drop:', dropCodes);

      // Remove existing promos that got bumped by higher-priority entries
      var existingToRemove = dropCodes.filter(function(pc) {
        return existingCodes.indexOf(pc) !== -1;
      });

      if (existingToRemove.length > 0) {
        console.log('[GWP Priority] Removing bumped promos:', existingToRemove);
        existingToRemove.forEach(function(pc) {
          existingGWP.filter(function(g) { return g.promoCode === pc; }).forEach(function(item) {
            cartJSUpdateQuery(item.key, 0, {});
          });
        });
        // Don't add in the same cycle - let removals complete first
        return;
      }

      // Add new promos that made the priority cut
      var newToAdd = keepCodes.filter(function(pc) {
        return eligibleNewCodes.indexOf(pc) !== -1;
      });

      if (newToAdd.length > 0) {
        console.log('[GWP Priority] Adding within cap:', newToAdd);
        newToAdd.forEach(function(pc) {
          dom.addItems.filter(function(a) { return a.promoCode === pc; }).forEach(function(item) {
            cartJSAddQuery(item.vid, 1, item.properties);
          });
        });
      }
    }
  });
}
// end: GWP Priority System

//start: calculate free gift GWP progress bar
calculateProgressGWP = (currentVal, targetVal) => {
  var freeGiftSection = $('.jsc-cart-freegift-section');
  var cartMinText = freeGiftSection.find('.cart-shipping__wrapper').attr('minprice-aud');
  var cartMinVal = parseInt(cartMinText);
  var progressBar = freeGiftSection.find('.cart-shippingThreshold__progress');
  var progressNum = freeGiftSection.find('.cart-shipping__num');
  var progressOuter = freeGiftSection.find('.cart-shipping__numOuter');
  var successMsg = freeGiftSection.find('.cart-shipping__success');
  var freeItemId = freeGiftSection.find('.cart-shipping__wrapper').attr('data-item-id');
  var isGwpInCart = false;

  if (freeGiftSection.length > 0) {
    $.when($.getJSON('/cart.js', function(cart) {
      var _totalPrice = cart.total_price;
      var $cartItems = cart.items;

      for (var i = 0; i < $cartItems.length; i++) {
        var $itemID = $cartItems[i].id;
        var $itemGwpProp = $cartItems[i].properties['_Cart_GWP'];
        var $itemGwpPropPromo = $cartItems[i].properties['_Cart_Gift'];

        if (freeItemId == $itemID && $itemGwpProp == 'Free Gift' && $itemGwpPropPromo == 1) {
          isGwpInCart = true;
        }
      }
      console.log('isGwpInCart',isGwpInCart);
      
      if (_totalPrice > 0) {
        freeGiftSection.removeClass('d-none');
        var calcFreeDeliveryVal = (cartMinVal - _totalPrice) / 100;
        var progressWidth = Math.round(100 * _totalPrice / cartMinVal);
        if (progressWidth >= 100) {
          progressWidth = 100;
        }
        var progressWidthPercent = progressWidth.toString() + '%';

        progressBar.each(function() {
          $(this).css({
            width: progressWidthPercent
          });
        });

        if (_totalPrice >= cartMinVal) {
          progressOuter.hide();
          successMsg.show();
          if (isGwpInCart == false) {
            $('.jsc-cart-items-section').append('<input type="hidden" value="'+ freeItemId +'" class="jsc-cart-gift" data-promo="1">');
            // masterPromo();
          } else {
            $('.jsc-cart-items-section .jsc-cart-gift').remove();
          }
          
        } else {
          progressNum.text(calcFreeDeliveryVal);
          progressOuter.show();
          successMsg.hide();
          if (isGwpInCart == true) {
            $('.jsc-cart-items-section').append('<input type="hidden" value="'+ freeItemId +'" class="jsc-cart-gift-remove jsc-promo-1">');
            //isGwpInCart = false;
            // masterPromo();
          }
        }
      }
      else{
        //console.log('cart Total',_totalPrice);
        freeGiftSection.addClass('d-none');
      }
      
    })).then(function() {
      masterPromo();
    });
  } else {
    masterPromo();
  }
};
updateGWPbar = () => {
  if (window.__jscGwpBarTimeoutId) {
    clearTimeout(window.__jscGwpBarTimeoutId);
  }
  window.__jscGwpBarTimeoutId = setTimeout(function() {
    window.__jscGwpBarTimeoutId = null;
    calculateProgressGWP();
  }, 500);
}
$(document).on('cart:updated product-ajax:added', function(event) {
  updateGWPbar();
});
//end: calculate free gift GWP progress bar


wishlistButtonClicked = (e, button) => {
  e.preventDefault();
  const productId = button.dataset.productId;
  const customerId = button.dataset.customerId;
  const isActive = button.dataset.active === 'true';
  const payload = {
    shop_id: "kimstore-enterprise-corp.myshopify.com",
    customer_id: customerId,
    product_id: productId
  };
  const addUrl = "https://simple-wishlist-app.webmavens.com/api/addToWishlist";
  const deleteUrl = "https://simple-wishlist-app.webmavens.com/api/deleteFromWishlist";

  const addBtns = document.getElementsByClassName("custom-wishlist-btn-"+productId);
  const activeDiv = document.getElementsByClassName("active-"+productId);
  const inactiveDiv = document.getElementsByClassName("inactive-"+productId);

  if(isActive){  
    fetch(deleteUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams(payload).toString()
    })
    .then(response => response.json())
    .then(data => {
      console.log("Delete Wishlist response:", data);

      for(let el of addBtns) {
        el.setAttribute("data-active", "false");
      }
      for (let el of activeDiv) { 
        el.style.display="none";
      }
      for (let el of inactiveDiv) { 
        el.style.display="block";
      }
    })
    .catch(error => {
      console.error("Delete Wishlist failed:", error);
    });
  }
  else {
    fetch(addUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams(payload).toString()
    })
    .then(data => {
      console.log("Add to Wishlist response:", data);
      for(let el of addBtns) {
        el.setAttribute("data-active", "true");
      }
      for (let el of activeDiv) { 
        el.style.display="block";
      }
      for (let el of inactiveDiv) { 
        el.style.display="none";
      }
    })
    .catch(error => {
      console.error("Add to Wishlist failed:", error);
    });
  }
}

$(function (){
  const observer = new MutationObserver((mutationsList, observer) => {
    const addBtns = document.querySelectorAll(".custom-wishlist-btn");
    let processedProductId = {};
    
    addBtns.forEach(el=>{
      const productId = el.dataset.productId;
      const addBtn = document.querySelectorAll(".custom-wishlist-btn-"+productId);
      const activeDiv = document.getElementsByClassName("active-"+productId);
      const inactiveDiv = document.getElementsByClassName("inactive-"+productId);
      if(processedProductId[productId] != undefined){
        el.dataset.processed = "true";
        if(processedProductId[productId] === 1){
            for(let el of addBtn) {
            el.setAttribute("data-active", "true");
            }
            for (let el of activeDiv) { 
            el.style.display="block";
            }
            for (let el of inactiveDiv) { 
            el.style.display="none";
            }
        }
        else{
            for(let el of addBtn) {
            el.setAttribute("data-active", "false");
            }
            for (let el of activeDiv) { 
            el.style.display="none";
            }
            for (let el of inactiveDiv) { 
            el.style.display="block";
            }
        }
      }

      if(!el.dataset.processed){
        el.dataset.processed = "true";

        const productTitle = el.dataset.productName;
        const customerId = el.dataset.customerId;
        const payload = {
          shop_id: "kimstore-enterprise-corp.myshopify.com",
          customer_id: customerId,
          product_id: productId
        };
        const checkUrl = "https://simple-wishlist-app.webmavens.com/api/checkWishlist";

        fetch(checkUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams(payload).toString()
        })
        .then(response => response.json())
        .then(data => {
            console.log("Wishlist check response "+productTitle+": ", data);
            
            processedProductId = {
              ...processedProductId,
              productId: data,
            }
            if(data === 1){
                for(let el of addBtn) {
                el.setAttribute("data-active", "true");
                }
                for (let el of activeDiv) { 
                el.style.display="block";
                }
                for (let el of inactiveDiv) { 
                el.style.display="none";
                }
            }
            else{
                for(let el of addBtn) {
                el.setAttribute("data-active", "false");
                }
                for (let el of activeDiv) { 
                el.style.display="none";
                }
                for (let el of inactiveDiv) { 
                el.style.display="block";
                }
            }
        })
        .catch(error => {
            console.error("Wishlist check failed "+productTitle+":", error);
        });
      }
    });
  });

  // Start observing the whole document for added nodes
  observer.observe(document.body, { childList: true, subtree: true });
});

productCollapsibleTabClicked = (e, button) => {
  // Allow clicks inside the accordion content (e.g. links) to behave normally.
  // This handler is attached to the <details>, so it also receives bubbled clicks.
  const clickedSummary = e.target && e.target.closest && e.target.closest('summary');
  if (!clickedSummary || !button.contains(clickedSummary)) return;

  const isExpanded = button.getAttribute('aria-expanded') === 'true';
  if (isExpanded) {
    hideProductDescriptionBlocks(false);
    setTimeout(() => {
      button.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      });
    }, 200);
  }
};

productAccordionClicked = (e, button) => {
  // Allow clicks inside the accordion content (e.g. links) to behave normally.
  const clickedSummary = e.target && e.target.closest && e.target.closest('summary');
  if (!clickedSummary || !button.contains(clickedSummary)) return;

  const isExpanded = button.getAttribute('aria-expanded') === 'true';
  if (isExpanded) {
    hideProductDescriptionBlocks(true);
    setTimeout(() => {
      button.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }, 100);
  } else {
    hideProductDescriptionBlocks(false);
  }
};

hideProductDescriptionBlocks = (hide) => {
  const productDescription = document.querySelectorAll('.product-description-block');
  if(productDescription) {
    productDescription.forEach((block) => {
      block.style.display = hide ? 'none' : 'block';
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  function moveAccordion() {
    const wrapper = document.querySelector(".product__blocks-below-media");
    const delivery = document.querySelector(".product__block--icon-with-text-vertical");

    if (!wrapper || !delivery) return;

    if (window.innerWidth < 768) { // mobile
      if (delivery.nextElementSibling !== wrapper) {
        delivery.insertAdjacentElement("afterend", wrapper);
        wrapper.style.marginTop = "0";
      }
    } else {
      const mediaContainer = document.querySelector(".product__media-container");
      if (mediaContainer && mediaContainer !== wrapper.parentNode) {
        mediaContainer.appendChild(wrapper);
      }
    }
  }

  moveAccordion();
  window.addEventListener("resize", moveAccordion);
});

equalizeCartProductCardHeight = () => {
  var items = document.getElementsByClassName("cart-product-cart__info");
  if (!items.length) return;

  var maxHeight = 0;

  // get tallest height
  for (var i = 0; i < items.length; i++) {
    var h = items[i].offsetHeight;
    if (h > maxHeight) {
      maxHeight = h;
    }
  }

  // apply tallest height to all
  for (var i = 0; i < items.length; i++) {
    items[i].style.height = maxHeight + "px";
  }
}

//start: PDP description to set max height 500px, exceeds then show view more
document.addEventListener('DOMContentLoaded', function() {
  const descriptionText = document.querySelector('.product-description-text');
  if (!descriptionText) return;

  const isMobile = window.innerWidth <= 768;
  const maxHeight = isMobile
      ? window.innerHeight * 2   // mobile: after 2nd fold
      : 500;                     // desktop: 500px

  if (descriptionText.scrollHeight > maxHeight) {
    descriptionText.style.maxHeight = maxHeight + 'px';
    descriptionText.style.overflow = 'hidden';
  }
});
//end: PDP description to set max height 500px, exceeds then show view more

//start: cart add-on
addUpsell = (e) => {
  var varID = $(e).data('id');
  var varAvail = $(e).data('available');
  var varQty = 1;
  var propsObj = {};
  // console.log('clickkkk',varID);

  if (varAvail == true) {
    propsObj['_addon_item'] = true;
    console.log('add this variant',varID);
    CartJS.addItem(varID, varQty, propsObj,
      {
        "success": function(data, textStatus, jqXHR) {
          console.log('Added item to cart');
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          console.log("Error occur !", errorThrown, jqXHR);
        }
      });
  }
}
//end: cart add-on

//start: slider with multicolumn redirection
multicolumnRedirectPage = (link) => {
  window.location.href = link;
}
//end: slider with multicolumn redirection
